import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import axios from "../../Uri";
import "react-toastify/dist/ReactToastify.css";

function InNotice() {
  let userData = JSON.parse(sessionStorage.getItem("userdata"));
  let userId = userData.data.userId;
  console.log(userId);
  const [data, setData] = useState([]);
  const columns = [
    { Header: "firstName", accessor: "firstName", width: "25%", color: "red" },
    { Header: "buildingName", accessor: "buildingName", width: "30%" },
    { Header: "id", accessor: "id" },
    { Header: "personalNumber", accessor: "personalNumber", width: "30%" },
    { Header: "checkInDate", accessor: "checkInDate", width: "30%" },
    { Header: "plannedCheckOutDate", accessor: "plannedCheckOutDate", width: "30%" },
    { Header: "bedId", accessor: "bedId", width: "30%" },
  ];
  useEffect(() => {
    axios
      .get(
        "/guest/getGuestAboutToCheckOut/RegulatInNotice/Daily-Monthly-Active"
      )
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
        // toast.error("Server Error")
      });
  }, []);
  const obje = { createdBy: userId };
  return (
    <Grid container>
      <Grid xs={12}>
        <DataTable
          canSearch="true"
          table={{
            columns: columns,
            rows: data,
          }}
        />
      </Grid>
    </Grid>
  );
}
export default InNotice;
